import PropTypes from 'prop-types';

/** Shared supervision PropTypes shape for CancelPensionerModal and CancelSupervisionModal. */
export const supervisionPropTypes = PropTypes.shape({
  reference: PropTypes.string,
  main_informations: PropTypes.shape({
    start_date: PropTypes.string,
    end_date: PropTypes.string
  }),
  address: PropTypes.shape({
    petsitting_address: PropTypes.shape({
      address: PropTypes.shape({
        state: PropTypes.string
      })
    })
  })
}).isRequired;

/** Shared anounce PropTypes shape for CancelPensionerModal and CancelSupervisionModal. */
export const anouncePropTypes = PropTypes.shape({
  description: PropTypes.string
}).isRequired;
